var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable @typescript-eslint/dot-notation */
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { updateWhenLocaleChanges } from '@lit/localize';
import { v4 as uuid4 } from 'uuid';
import Slider from 'devextreme/ui/slider';
import dxButton from 'devextreme/ui/button';
/**
 * Represents the time navigator
 */
let DinapsisTimeNavigator = class DinapsisTimeNavigator extends LitElement {
    constructor() {
        super();
        /**
         * A property that is used to save the actual value of slider
         */
        this.actualValue = 0;
        /**
         * A property that is used to save the SliderControl element
         */
        this.sliderSelector = undefined;
        /**
         * A property that is used to set the width of each marker item of slider
         */
        this.markerElementWidth = 0;
        /**
         * A property that is used to set the event wich control the auto update
         */
        this.initAutoNavigationEvent = null;
        /**
         * A property that is used to set the auto navigation start when it renders
         */
        this.navigationAutoStart = true;
        /**
         * A property that is used to control if navigation is in progress
         */
        this.isNavigationAutoEnabled = false;
        /**
         * A property that is used to set the data to navigator
         */
        this.model = [];
        /**
         * A property that is used to set the id of the div that the time-navigator is rendered in.
         */
        this.timeNavigatorId = `dinapsis-time-navigator-${uuid4()}`;
        /**
         * A property that is used to set the time in seconds between the position change.
         */
        this.autoNavigationTime = 5;
        updateWhenLocaleChanges(this);
    }
    /**
     * The `disconnectedCallback` function in TypeScript overrides the default behavior to cancel auto
     * navigation.
     */
    disconnectedCallback() {
        super.disconnectedCallback();
        this.cancelAutoNavigation();
    }
    /**
     * The createRenderRoot() function
     * is a function that is called by the LitElement base class when the
     * element is first created. It returns the element itself,
     * which means that the element will be
     * rendered in place, rather than in a shadow DOM.
     * Helps to use the css.
     * @returns The element itself.
     */
    createRenderRoot() {
        return this;
    }
    /**
     * The above function is a lifecycle hook that is called when the component is first updated.
     * It is used to initialize the time navigator.
     */
    firstUpdated() {
        const container = document.querySelector(`#${this.timeNavigatorId} .slider-container__content__slider`);
        // If not exist container or not have data
        if (!container)
            return;
        if (!this.model || this.model.length === 0)
            return;
        this.createNewSlider(container);
        this.generateTimeNavigationButtons();
        this.generateExpandButton();
        this.onEventResizeWindow();
        // Start auto navigation
        if (this.navigationAutoStart)
            this.startAutoNavigation();
        this.togglePlayPauseButtons();
        // Emit first position always
        this.emitChangeSliderEvent();
    }
    /**
     * If any property has changed when finish update this method is called an
     * depending on wich property has been modified,
     * it executes its update method
     * @param changedProperties - Map<string, unknown>
     */
    updated(changedProperties) {
        if (changedProperties.has('model')) {
            this.restartTimeNavigator();
            this.eventResizeWindow();
            const oldValue = changedProperties.get('model');
            if (!oldValue && oldValue === this.model)
                return;
            // Dif Destroy Slider
            this.removeSlider();
            // Create new Slider Element
            const container = document.querySelector(`#${this.timeNavigatorId} .slider-container__content__slider`);
            if (!container)
                return;
            this.createNewSlider(container);
        }
    }
    /**
     * The function `startAutoNavigation` enables automatic navigation
     * by setting up a timer to call the `forwardNavigation` method every 5 seconds.
     */
    startAutoNavigation() {
        if (this.initAutoNavigationEvent)
            return;
        this.isNavigationAutoEnabled = true;
        this.initAutoNavigationEvent = setInterval(() => {
            this.forwardNavigation();
        }, this.autoNavigationTime * 1000);
    }
    /**
     * The function `updateValueTimeLine` updates the value of a slider element with the actual value.
     */
    updateValueTimeLine() {
        var _a;
        (_a = this.sliderSelector) === null || _a === void 0 ? void 0 : _a.option('value', this.actualValue);
    }
    /**
     * The `restartTimeNavigator` function resets
     * the `actualValue` property to 0 and updates the value timeline.
     */
    restartTimeNavigator() {
        this.actualValue = 0;
        this.updateValueTimeLine();
    }
    /**
     * The function `generateTimeNavigationButtons` creates
     * time navigation buttons with specific icons
     * and callbacks.
     */
    generateTimeNavigationButtons() {
        const btnBack = document.querySelector(`#${this.timeNavigatorId} .time-buttons__content__back__btn`);
        const btnPlay = document.querySelector(`#${this.timeNavigatorId} .time-buttons__content__play__btn`);
        const btnPause = document.querySelector(`#${this.timeNavigatorId} .time-buttons__content__pause__btn`);
        const btnForward = document.querySelector(`#${this.timeNavigatorId} .time-buttons__content__forward__btn`);
        const btnBackArgs = {
            height: '32px',
            icon: 'skip_previous',
            className: 'time-buttons__content__back__icon',
            callBack: () => this.backNavigation(),
        };
        const btnPlayArgs = {
            height: '40px',
            icon: 'play_arrow',
            className: 'time-buttons__content__play__icon',
            callBack: () => this.playNavigation(),
        };
        const btnPauseArgs = {
            height: '40px',
            icon: 'pause',
            className: 'time-buttons__content__play__icon',
            callBack: () => this.pauseNavigation(),
        };
        const btnForwardArgs = {
            height: '32px',
            icon: 'skip_next',
            className: 'time-buttons__content__forward__icon',
            callBack: () => this.forwardNavigation(),
        };
        this.generateButton(btnBack, btnBackArgs);
        this.generateButton(btnPlay, btnPlayArgs);
        this.generateButton(btnPause, btnPauseArgs);
        this.generateButton(btnForward, btnForwardArgs);
    }
    /**
     * The function `togglePlayPauseButtons` toggles the display of play
     * and pause buttons based on the value of `isNavigationAutoEnabled`.
     */
    togglePlayPauseButtons() {
        const btnPlay = document.querySelector(`#${this.timeNavigatorId} .time-buttons__content__play__btn`);
        const btnPause = document.querySelector(`#${this.timeNavigatorId} .time-buttons__content__pause__btn`);
        if (this.isNavigationAutoEnabled) {
            btnPlay.style.display = 'none';
            btnPause.style.display = '';
        }
        else {
            btnPause.style.display = 'none';
            btnPlay.style.display = '';
        }
    }
    /**
     * The function `generateExpandButton` generates an expand button with specific properties and a
     * callback function to toggle expand.
     */
    generateExpandButton() {
        const btnExpand = document.querySelector(`#${this.timeNavigatorId} .button-expand__content`);
        const btnArgs = {
            height: '32px',
            icon: 'keyboard_double_arrow_right',
            className: 'button-expand__content__icon button-expand__content__icon--collapsed',
            callBack: () => this.toggleExpand(),
        };
        this.generateButton(btnExpand, btnArgs);
    }
    /**
     * The function `generateButton` creates a button element with specified properties and a callback
     * function.
     * @param {HTMLElement} element - The `element` parameter is the HTML element to which the button
     * will be attached.
     * @param {IDinapsisTimeNavigatorButtonTime} args - The TimeNavigatorButtonTime properties with
     * wich the button is to be constructed
     */
    generateButton(element, args) {
        const { height, icon, className, callBack, } = args;
        // eslint-disable-next-line new-cap, no-new
        new dxButton(element, {
            focusStateEnabled: false,
            height,
            stylingMode: 'text',
            icon: 'none',
            onClick: callBack,
            template: () => `<span class="dx-icon ${className} material-icons-round">${icon}</span>`,
        });
    }
    /**
     * The `onEventResizeWindow` function adds an event listener
     * for window resize events that triggers the `eventResizeWindow` method.
     */
    onEventResizeWindow() {
        window.addEventListener('resize', () => {
            this.eventResizeWindow();
        }, true);
    }
    /**
     * The function creates a new slider element with specific properties and events,
     * including a tooltip displaying the label of the selected value from a model.
     * @param {Element} container - The `container` parameter in the `createNewSlider` function is an
     * Element that represents the HTML element in which the slider will be created.
     */
    createNewSlider(container) {
        const self = this;
        this.sliderSelector = new Slider(container);
        // Properties
        this.sliderSelector.option('min', 0);
        this.sliderSelector.option('max', this.model.length - 1);
        this.sliderSelector.option('value', 0); // Auto select first position
        this.sliderSelector.option('showRange', false);
        this.sliderSelector.option('steps', 1);
        this.sliderSelector.option('valueChangeMode', 'onHandleRelease');
        // Events
        this.sliderSelector.on('valueChanged', (e) => this.triggerUpdateValue(e));
        this.sliderSelector.option('tooltip', {
            enabled: true,
            format(value) {
                return `${self.model[value].label}`;
            },
            showMode: 'always',
        });
    }
    /**
     * The function `removeSlider` removes a slider element if it exists.
     */
    removeSlider() {
        if (!this.sliderSelector)
            return;
        this.sliderSelector.dispose();
        this.sliderSelector = undefined;
    }
    /**
     * The function `triggerUpdateValue` updates the `actualValue` property
     * and emits a change event.
     * @param {ValueChangedEvent} e - The parameter `e` in the `triggerUpdateValue`
     * function is of type `ValueChangedEvent`.
     */
    triggerUpdateValue(e) {
        const { value } = e;
        this.actualValue = value;
        this.emitChangeSliderEvent();
    }
    /**
     * The function generates slider markers and updates the HTML content accordingly.
     */
    generateSliderMarkers() {
        const sliderMarkers = document.querySelector(`#${this.timeNavigatorId} .slider-container__content__markers`);
        if (!sliderMarkers)
            return;
        sliderMarkers.innerHTML = this.generateMarkerItems();
    }
    /**
     * The function calculates the width of elements within a slider based on their relative sizes.
     */
    calculateAutoWidthElements() {
        const sliderWrapper = document.querySelector(`#${this.timeNavigatorId} .dx-slider-wrapper`);
        const sliderWrapperWidth = sliderWrapper.offsetWidth;
        const sliderElement = document.querySelector(`#${this.timeNavigatorId} .dx-slider-bar`);
        const sliderElementWidth = sliderElement.offsetWidth;
        const element = (sliderElementWidth * 100) / sliderWrapperWidth;
        const withElement = element / (this.model.length - 1);
        this.markerElementWidth = withElement;
    }
    /**
     * The `eventResizeWindow` function in TypeScript calculates
     * auto width elements and generates slider markers.
     */
    eventResizeWindow() {
        this.calculateAutoWidthElements();
        this.generateSliderMarkers();
    }
    /**
     * The function `generateMarkerItems` creates a string of HTML elements
     * representing markers based on the model data.
     * @returns Returns a string containing HTML `<div>` elements with
     * marker symbols "|" inside. The width of each `<div>` element is determined by the
     * `markerElementWidth` property of the object calling the function.
     */
    generateMarkerItems() {
        let itemElements = '';
        for (let i = 0; i < this.model.length; i += 1) {
            if (i === this.model.length - 1) {
                itemElements += '<div>|</div>';
            }
            else {
                itemElements += `<div style="width: ${this.markerElementWidth}%">|</div>`;
            }
        }
        return itemElements;
    }
    /**
     * The function `toggleExpand` toggles the visibility of certain elements in a time navigator
     * container based on a button click. To allow the component to collapse and expand.
     */
    toggleExpand() {
        const container = document.querySelector(`#${this.timeNavigatorId} .time-navigator__container`);
        if (!container)
            return;
        const btnExpand = document.querySelector(`#${this.timeNavigatorId} .button-expand__content__icon`);
        const btnBackContainer = document.querySelector(`#${this.timeNavigatorId} .time-buttons__content__back`);
        const btnForwardContainer = document.querySelector(`#${this.timeNavigatorId} .time-buttons__content__forward`);
        const timeButtonsContainer = document.querySelector(`#${this.timeNavigatorId} .time-buttons`);
        const sliderContainer = document.querySelector(`#${this.timeNavigatorId} .slider-container`);
        const isCollapsed = btnExpand.classList.contains('button-expand__content__icon--collapsed');
        const btnExpandClasses = {
            collapsed: 'button-expand__content__icon--collapsed',
            expanded: 'button-expand__content__icon--expanded',
        };
        const containerClasses = {
            collapsed: 'time-navigator__container__full-width',
            expanded: 'time-navigator__container__collapsed-width',
        };
        const timeClasses = {
            collapsed: 'time-buttons__full-width',
            expanded: 'time-buttons__collapsed-width',
        };
        if (isCollapsed) {
            btnExpand.classList.replace(btnExpandClasses.collapsed, btnExpandClasses.expanded);
            container.classList.replace(containerClasses.collapsed, containerClasses.expanded);
            timeButtonsContainer.classList.replace(timeClasses.collapsed, timeClasses.expanded);
            sliderContainer.style.display = 'none';
            btnBackContainer.style.display = 'none';
            btnForwardContainer.style.display = 'none';
        }
        else {
            btnExpand.classList.replace(btnExpandClasses.expanded, btnExpandClasses.collapsed);
            container.classList.replace(containerClasses.expanded, containerClasses.collapsed);
            // Sync time with css animation
            const syncAnimation = new Promise((resolve) => {
                setTimeout(() => {
                    timeButtonsContainer.classList.replace(timeClasses.expanded, timeClasses.collapsed);
                    sliderContainer.style.display = '';
                    btnBackContainer.style.display = '';
                    btnForwardContainer.style.display = '';
                    resolve();
                }, 500);
            });
            syncAnimation.then(() => {
                // Force to create markers
                this.eventResizeWindow();
            });
        }
    }
    /**
     * The `backNavigation` function decrements the `actualValue` property and updates the value
     * timeline, with a check to navigate to the last item if at the first position.
     */
    backNavigation() {
        // Check if is first position to navigate to last item
        if (this.actualValue === 0)
            this.actualValue = this.model.length;
        this.actualValue -= 1;
        this.updateValueTimeLine();
    }
    /**
     * The function `playNavigation` starts auto navigation and toggles play/pause buttons.
     */
    playNavigation() {
        this.startAutoNavigation();
        this.togglePlayPauseButtons();
    }
    /**
     * The `pauseNavigation` function in TypeScript cancels auto navigation and toggles play/pause
     * buttons.
     */
    pauseNavigation() {
        this.cancelAutoNavigation();
        this.togglePlayPauseButtons();
    }
    /**
     * The function `cancelAutoNavigation` stops automatic navigation by clearing
     * the interval and updating related properties.
     */
    cancelAutoNavigation() {
        if (!this.initAutoNavigationEvent)
            return;
        clearInterval(this.initAutoNavigationEvent);
        this.initAutoNavigationEvent = null;
        this.isNavigationAutoEnabled = false;
    }
    /**
     * The `forwardNavigation` function increments the `actualValue` property by 1
     * and updates the value timeline, restarting the navigation if the value is the last item.
     */
    forwardNavigation() {
        // Check if value is last item to navigate to first item
        if (this.actualValue === this.model.length - 1) {
            this.restartTimeNavigator();
            return;
        }
        this.actualValue += 1;
        this.updateValueTimeLine();
    }
    /**
     * The function `emitChangeSliderEvent` dispatches a custom event named 'change-position' with the
     * current model's detail as data.
     */
    emitChangeSliderEvent() {
        const model = this.model[this.actualValue];
        this.dispatchEvent(new CustomEvent('change-position', { detail: { model } }));
    }
    /**
     * The `render` function overrides the default rendering behavior to display a time navigator
     * component with various nested elements.
     * @returns The `render()` method is returning a HTML template literal that represents a time
     * navigator component with various nested elements such as buttons, sliders, and labels. The
     * structure of the returned HTML includes a container with specific classes and IDs, nested div
     * elements with different classes for styling, and placeholders
     * for dynamic content like labels from the model data.
     */
    render() {
        return html `
      <div id="${this.timeNavigatorId}" class="time-navigator">
        <div class="time-navigator__container time-navigator__container__full-width">
          <div class="time-navigator__container__content">
            <div class="time-navigator__container__content__item button-expand">
              <div class="button-expand__content"></div>
            </div>
            <div class="time-navigator__container__content__item time-buttons time-buttons__full-width">
              <div class="time-buttons__content">
                <div class="time-buttons__content__back">
                  <div class="time-buttons__content__back__btn"></div>
                </div>
                <div class="time-buttons__content__play">
                  <div class="time-buttons__content__play__btn"></div>
                  <div class="time-buttons__content__pause__btn"></div>
                </div>
                <div class="time-buttons__content__forward">
                  <div class="time-buttons__content__forward__btn"></div>
                </div>
              </div>
            </div>
            <div class="time-navigator__container__content__item slider-container">
              <div class="slider-container__content">
                <div class="slider-container__content__slider"></div>
                <div class="slider-container__content__markers"></div>
              </div>
              <div class="slider-container__display-labels">
                <div class="slider-container__display-labels__item">${this.model[0].label}</div>
                <div class="slider-container__display-labels__item">${this.model[this.model.length - 1].label}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    property({ type: Array })
], DinapsisTimeNavigator.prototype, "model", void 0);
__decorate([
    property({ type: String })
], DinapsisTimeNavigator.prototype, "timeNavigatorId", void 0);
__decorate([
    property({ type: Number })
], DinapsisTimeNavigator.prototype, "autoNavigationTime", void 0);
DinapsisTimeNavigator = __decorate([
    customElement('dinapsis-time-navigator')
], DinapsisTimeNavigator);
export { DinapsisTimeNavigator };
//# sourceMappingURL=dinapsis-time-navigator.js.map